<template>
  <div class="mobile-bossbanner-box">
    <div class="mobile-boss-person-box">
      <img :src="getImgUrl(leaderImg)" class="mobile-person" alt="" />
      <div class="mobile-text-box">
        <div class="mobile-en-title">{{ "co-founder".toUpperCase() }}</div>
        <div class="mobile-cn-title">联合创始人</div>
      </div>
    </div>
    <div class="mobile-introduce-box" ref="introduceBox">
      <div
        v-for="(item, index) in leaderList"
        :key="index"
        :class="[
          'mobile-introduce-item1',
          { 'mobile-introduce-item2': isSwapped != index },
        ]"
        @click="swapItems(index)"
      >
        <img src="@/assets/team/icon.png" alt="" />
        <div class="mobile-text-box">
          <div class="mobile-text" v-html="item.content"></div>
          <div class="mobile-username-box">
            {{ item.title }} <span> / 联合创始人</span>
          </div>
        </div>
      </div>
      <!-- <div :class="['mobile-introduce-item1']" @click="swapItems(2)">
        <img src="@/assets/team/icon.png" alt="" />
        <div class="mobile-text-box">
          <div class="mobile-text">
            衡水市桃城区第七届政协委员
            <br />
            策划方案的主导者，简单而专注，帮客户赢得市场，拥有丰富的管理经验，曾成功创建多种团体组织，敏锐的市
          </div>
          <div class="mobile-username-box">
            冷建斐 <span> / 联合创始人</span>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leaderList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    leaderImg() {
      return this.leaderList.length
        ? this.leaderList[this.isSwapped].thumb
        : "";
    },
  },
  data() {
    return {
      isSwapped: 0,
      isAnimating: false,
    };
  },
  mounted() {
    setInterval(() => {
      this.swapItems();
    }, 5000);
  },
  methods: {
    swapItems() {
      if (this.isAnimating) return;
      this.isAnimating = true;

      // 添加过渡动画
      const content = this.$refs.introduceBox;
      content.style.transition =
        "transform 0.5s ease-in-out, opacity 0.5s ease-in-out";
      this.isSwapped = this.isSwapped === 0 ? 1 : 0;
      this.leaderList.reverse();
      setTimeout(() => {
        content.style.transform = "translateX(-100%)";
        content.style.opacity = "0";
        setTimeout(() => {
          this.isSwapped = 0;
          content.style.transform = "translateX(0)";
          content.style.opacity = "1";
          this.isAnimating = false;
        }, 500);
      }, 500);

      // 等待动画完成
      // setTimeout(() => {
      //   // 重置动画状态
      //   setTimeout(() => {}, 500);
      // }, 500);
    },
  },
};
</script>

<style scoped>
.mobile-bossbanner-box {
  width: 46.875rem;
  height: 95.4375rem;
  padding-top: 12rem;
  background: #0d0d0d;
}

.mobile-bossbanner-box .mobile-boss-person-box {
  position: relative;
  width: 28rem;
  height: 39.125rem;
  background-image: url("~@/assets/mobile/team/person-bg.png");
  background-size: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.mobile-bossbanner-box .mobile-boss-person-box .mobile-person {
  width: calc(100% - 0.875rem);
  margin-bottom: 0.875rem;
}

.mobile-bossbanner-box .mobile-boss-person-box .mobile-text-box {
  position: absolute;
  left: 22.8125rem;
  top: 14.4375rem;
}

.mobile-bossbanner-box
  .mobile-boss-person-box
  .mobile-text-box
  .mobile-en-title {
  font-weight: 400;
  font-size: 1.5rem;
  color: #ffffff;
  white-space: nowrap;
}

.mobile-bossbanner-box
  .mobile-boss-person-box
  .mobile-text-box
  .mobile-cn-title {
  margin-top: 2.5rem;
  font-weight: 500;
  font-size: 3.125rem;
  color: #ffcfa0;
  white-space: nowrap;
}

.mobile-introduce-box {
  width: 44.375rem;
  margin: 4.625rem 0 0 2.5rem;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  transform: translateX(0);
  opacity: 1;
}

.mobile-introduce-box::-webkit-scrollbar {
  display: none;
}

.mobile-introduce-box .mobile-introduce-item1 {
  flex-shrink: 0;
  width: 36.875rem;
  height: 25.1875rem;
  background: #181818;
  border-radius: 0.3125rem;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  padding: 3rem 2.5rem;
  margin-right: 2rem;
  transition: all 0.5s ease;
}

.mobile-introduce-box .mobile-introduce-item1:last-child {
  margin-right: 0;
}

.mobile-introduce-box .mobile-introduce-item1 img {
  width: 1.6875rem;
  height: 1.8125rem;
  margin-right: 2.0625rem;
  margin-top: 0.5rem;
}

.mobile-introduce-box .mobile-introduce-item1 .mobile-text-box .mobile-text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 1.5rem;
  color: #ffcfa0;
  line-height: 3.125rem;
}

.mobile-introduce-box
  .mobile-introduce-item1
  .mobile-text-box
  .mobile-username-box {
  margin-top: 1.75rem;
  font-weight: 400;
  font-size: 1.125rem;
  color: #ffffff;
}

.mobile-introduce-box
  .mobile-introduce-item1
  .mobile-text-box
  .mobile-username-box
  span {
  color: #666666;
  font-size: 0.875rem;
}

.mobile-introduce-item2 {
  opacity: 0.6;
  margin: 2.5rem 2rem 0 2.5rem;
  transform: scale(0.95);
  transition: all 0.5s ease;
}

.mobile-introduce-item2 .mobile-text {
  color: #ffffff !important;
}
</style>
